import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { Separator } from '@gik/ui';
import { DonationsValues } from '@gik/create';
import noop from '@gik/core/utils/noop';
import PayPalDonationProvider from '@gik/create/components/DonationProvider/PayPalDonationProvider';
import GoFundMeDonationProvider from '@gik/create/components/DonationProvider/GoFundMeDonationProvider';

export interface IDonationsContainerProps {
  asForm?: boolean;
  onChange?: (values: DonationsValues) => void;
  value: DonationsValues;
  disabled?: boolean;
  className?: string;
  direction?: 'vertical' | 'horizontal';
  variant?: 'create' | 'page-settings';
  trackingId?: string;
  recalculateHeightCallback?: () => void;
}

const blockName = 'donations-container';

export default function DonationsContainer({
  asForm = false,
  onChange = noop,
  value,
  className,
  direction = 'horizontal',
  variant,
  trackingId,
  recalculateHeightCallback,
}: IDonationsContainerProps) {
  const bem = bemBlock(blockName);

  return (
    <section className={bem(null, [{ [direction]: true }], className)}>
      <PayPalDonationProvider
        asForm={asForm}
        trackingId={trackingId}
        recalculateHeightCallback={recalculateHeightCallback}
        value={{
          payPalValue: value?.payPalValue,
          isPayPalValueValid: value?.isPayPalValueValid,
        }}
        variant={variant}
        onValueChange={payPalValue =>
          onChange({
            ...value,
            ...payPalValue,
          })
        }
      />

      <Separator
        className={bem('separator')}
        direction={direction === 'horizontal' ? 'vertical' : 'horizontal'}
        size={'none'}
      >
        and/or
      </Separator>

      <GoFundMeDonationProvider
        asForm={asForm}
        trackingId={trackingId}
        recalculateHeightCallback={recalculateHeightCallback}
        value={{
          gofundmeValue: value?.gofundmeValue,
          isGoFundMeValueValid: value?.isGoFundMeValueValid,
        }}
        variant={variant}
        onValueChange={gofundmeValue =>
          onChange({
            ...value,
            ...gofundmeValue,
          })
        }
      />
    </section>
  );
}
